import Toastr from "../../../../../itrust_common/components/Toastr";

const DEFAULT_STATE = {
  saving: false,
  graph_data: {},
  kpi_data: {},
  rpa_tab_logs: [],
  schedule_job_logs: []
}

let changes = null
export const tabReportReducer = (state = DEFAULT_STATE, action) => {
  const response = action.payload && (action.payload.data || action.payload.response)

  switch (action.type) {

    case 'TAB_LOGS_LOAD_PENDING':
    case 'TAB_DASHBOARD_LOAD_PENDING':
    case 'TAB_LOG_SYNC_PENDING':
      return { ...state, saving: true };

    case 'TAB_LOGS_LOAD_REJECTED':
    case 'TAB_DASHBOARD_LOAD_REJECTED':
    case 'TAB_SCHEDULE_LOGS_LOAD_REJECTED':
    case 'TAB_LOG_SYNC_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      changes = { saving: false }
      return { ...state, ...changes };

    case 'TAB_LOGS_LOAD_FULFILLED':
      changes = { saving: false, ...response }
      return { ...state, ...changes };

    case 'TAB_DASHBOARD_LOAD_FULFILLED':
      changes = { [`${response.meta.params}_data`]: { ...response.records }, meta: { ...response.meta }, saving: false }
      return { ...state, ...changes };

    case 'TAB_SCHEDULE_LOGS_LOAD_FULFILLED':
      changes = { ...response , saving: false }
      return { ...state, ...changes };

    case 'TAB_LOG_SYNC_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201)
      changes = { saving: false, ...response }
      return { ...state, ...changes };

    default:
      return state
  }
}